import { useTranslation } from 'react-i18next';
import spaceLogoRU from '#/shared/assets/logos/r7-space-dark_RU.svg';
import spaceLogoEN from '#/shared/assets/logos/r7-space-dark_EN.svg';
import spaceLogoLightRU from '#/shared/assets/logos/r7-space-light_RU.svg';
import spaceLogoLightEN from '#/shared/assets/logos/r7-space-light_EN.svg';

interface LogoProps {
  height?: number;
  className?: string;
  theme?: 'light' | 'dark';
}

export const SpaceLogo = ({ height = 30, className = '', theme = 'dark' }: LogoProps) => {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.language;
  let spaceLogo = spaceLogoRU;

  if (currentLanguage === 'ru') {
    spaceLogo = theme === 'light' ? spaceLogoLightRU : spaceLogoRU;
  } else {
    spaceLogo = theme === 'light' ? spaceLogoLightEN : spaceLogoEN;
  }

  return <img className={className} src={spaceLogo} alt={t('spaceLogoAlt')} height={height} />;
};
